/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Auth_TokenInputs */



/**
* | output |
* | --- |
* | "Authentication Token" |
*
* @param {Options_Integrations_Auth_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_auth_token = /** @type {((inputs?: Options_Integrations_Auth_TokenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Auth_TokenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jeton d'authentification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Authentifizierungstoken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Token di autenticazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Токен аутентификации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Token de autenticación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("身份验证令牌")
	if (locale === "ja") return /** @type {LocalizedString} */ ("認証トークン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रमाणीकरण टोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Token de autenticação")
	return /** @type {LocalizedString} */ ("Authentication Token")
});